var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 164,
    viewBox: "0 0 312 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 121.5C92.6503 121.5 102.5 131.35 102.5 143.5L102.5 151C102.5 158.18 108.32 164 115.5 164L290.002 164C302.152 164 312.002 154.15 312.002 142L312.002 107.5C312.002 100.32 306.181 94.5 299.002 94.5L286.002 94.5C276.061 94.5 268.002 86.4411 268.002 76.5L268.002 13C268.002 5.82031 262.181 4.52055e-06 255.002 3.56105e-06L22 -2.75775e-05C9.84973 -2.92013e-05 5.39906e-07 9.84971 1.20591e-06 22L5.94734e-06 108.5C6.34089e-06 115.68 5.8203 121.5 13 121.5L80.5 121.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceProduct);
export default __webpack_public_path__ + "static/media/invoiceProduct.0c285b184237505644deb963408b2944.svg";
export { ForwardRef as ReactComponent };